export enum EVENT_TYPE {
  Independent = 0,
  Collaborate = 1,
  Event = 2,
}
